import React from "react";
import { connect } from "react-redux";

import Loading from "components/Loading";

import { withT } from "services/translation/";

import Icon from "components/Icons/Icon";

import RoleSelect from "components/Enterprise/UserManagement/Common/RoleSelect";
import Features from "components/Enterprise/UserManagement/Common/Features";

// import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { Col, Card, Form, Button } from "react-bootstrap";

import { getPathRootFromRoute } from "services/redux/selectors/app/";
import { getGroupFromRoute } from "services/redux/selectors/groups";
import { getEnterpriseFromRoute } from "services/redux/selectors/enterprises";

import {
  requestUserManagementInviteStart,
  requestUserManagementInviteNotified,
  requestUserManagementSearchReset,
  loadUserManagementUserListStart
} from "services/redux/actions";
import {
  singleSiteUserGrantAccessStart,
  singleSiteUserGrantAccessNotified,
  loadSingleSiteUsersStart,
} from "services/redux/actions/singleSites";

import Alert from "components/Common/Alert";

import { devMode } from "services/redux/selectors/";

/**
 * UserInvite/ExistingUser
 *
 * Form for granting access to a group for the specified user.
 * Displays user details after a user has been searched
 *
 */
class ExistingUser extends React.Component {
  state = {
    role: ""
  };
  inviteUser = e => {
    e.preventDefault();

    const { pathRoot, origin, enterprise, group, users } = this.props;
    const group_id = (group && group.id) || (enterprise && enterprise.root_group_id);

    const { role } = this.state;

    const features = [];
    document
      .querySelectorAll("#ExistingUser .feature-checkbox input")
      .forEach(checkbox => checkbox.checked && features.push(checkbox.id));

    const { user } = users.actions.invite;

    if (origin === "Companies") {
      this.props.dispatch(
        singleSiteUserGrantAccessStart({
          sudo_site_id: this.props.sudoSiteId,
          invite_type: "company",
          invite_type_id: this.props.companyId,
          params: {
            user_id: users.actions.invite.user.id,
            conxtd_role_id: role,
          }
        })
      );
    } else if (origin === "SiteView") {
      const dispatchParams = {
        sudo_site_id: this.props.sudoSiteId,
        params: {
          user_id: users.actions.invite.user.id,
          conxtd_role_id: role,
        }
      }
      if (pathRoot === "enterprise") {
        dispatchParams["invite_type"] = "enterprise";
        dispatchParams["invite_type_id"] = enterprise.id;
      }
      this.props.dispatch(
        singleSiteUserGrantAccessStart(dispatchParams)
      );
    } else {
      this.props.dispatch(
        requestUserManagementInviteStart({
          email: user.email,
          emailConfirm: user.email,
          first_name: user.firstName,
          last_name: user.lastName,
          profile: {
            position: user.jobTitle || "",
            company: { name: user.company || "" },
            // These are hard coded for now but will need to be an
            // autocomplete select or something at some point #196
            locale: "en",
            timezone: "Europe/London"
          },
          enterprise_id: enterprise.id,
          group_id,
          role_id: role,
          featureIds: features,
          existing: true
        })
      );
    }
  };
  render() {
    const { pathRoot, origin, users, group, enterprise, t } = this.props;
    const group_id = (group && group.id) || (enterprise && enterprise.root_group_id);
    const groupName = (group && group.name) || (enterprise && enterprise.name);

    const { loading, user, error, success } = users.actions.invite;

    if (error.message) {
      Alert({
        text: t(`errors.invite${devMode() ? "_dev" : ""}`, error.message),
        icon: "error",
        didClose: () => {
          // Reset error message
          if (origin === "Companies" || origin === "SiteView") {
            this.props.dispatch(singleSiteUserGrantAccessNotified());
          } else {
            this.props.dispatch(requestUserManagementInviteNotified());
          }
        }
      });
    }
    if (success) {
      Alert({
        text: t("invite_success", user.firstName, user.lastName, (origin === "Companies" || origin === "SiteView") ? this.props.siteName : groupName),
        icon: "success",
        didClose: () => {
          // Reset error message
          if (origin === "Companies" || origin === "SiteView") {
            this.props.dispatch(singleSiteUserGrantAccessNotified());
          } else {
            this.props.dispatch(requestUserManagementInviteNotified());
          }
          // Refresh user list
          if (origin === "Companies") {
            this.props.dispatch(
              loadSingleSiteUsersStart({
                originType: "company",
                originId: this.props.companyId,
                sudo_site_id: this.props.sudoSiteId,
              })
            );
          } else if (origin === "SiteView") {
            const params = {
              sudo_site_id: this.props.sudoSiteId,
            }
            if (pathRoot === "enterprise") {
              params["originType"] = "enterprise";
              params["originId"] = enterprise.id;
            }
            this.props.dispatch(
              loadSingleSiteUsersStart(params)
            );
          } else {
            this.props.dispatch(
              loadUserManagementUserListStart({
                enterprise_id: enterprise.id,
                group_id: group_id
              })
            );
          }
          // Reset user search
          this.props.dispatch(requestUserManagementSearchReset());
        }
      });
    }

    return (
      <>
        <p>
          <b>{t("x_is_on_conxtd", user.email)}</b>
        </p>
        <p>{t(
          (origin === "Companies" || origin === "SiteView") ? "invite_existing_user_desc_single_site" : "invite_existing_user_description",
          (origin === "Companies" || origin === "SiteView") ? this.props.siteName : groupName
        )}</p>
        <Form onSubmit={this.inviteUser} id="ExistingUser">
          <Card bg="light">
            <Card.Body>
              <Card.Title className="text-uppercase font-weight-bold font-16">
                <Icon className="fas fa-user-circle pr-2" />

                {t("full_name", user.firstName || "", user.lastName || "")}
              </Card.Title>
              <Form.Row>
                <Form.Group controlId="formGroupUserInvite" as={Col} sm="12">
                  <Form.Label className="text-muted">
                    {t("email_address_input_label")}
                  </Form.Label>
                  <Form.Text className="font-14">{user.email}</Form.Text>
                </Form.Group>

                {user.company && (
                  <Form.Group controlId="formGroupUserCompany" as={Col} sm="4">
                    <Form.Label className="text-muted">
                      {t("job_title_input_label")}
                    </Form.Label>

                    <Form.Text className="font-14">
                      {user.company || ""}
                    </Form.Text>
                  </Form.Group>
                )}

                {origin !== "Companies" && origin !== "SiteView" && (
                  <Form.Group controlId="formGroupUserRole" as={Col} sm="4">
                    <Form.Label className="text-muted">
                      {t("role_input_label")}
                    </Form.Label>

                    <RoleSelect
                      onSelect={e => {
                        this.setState({ role: e.target.value });
                      }}
                    />
                  </Form.Group>
                )}

                {origin !== "Companies" && origin !== "SiteView" && (
                  <Form.Group controlId="formGroupFeatures" as={Col} sm="4">
                    <Form.Label className="text-muted">
                      {t("features_input_label")}
                    </Form.Label>

                    {/* TODO: features component */}

                    <Features />
                  </Form.Group>
                )}

                <Form.Group
                  className="text-right mb-0"
                  controlId="formGroupUserActions"
                  as={Col}
                  md="12">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      this.props.dispatch(requestUserManagementSearchReset());
                    }}
                    disabled={loading}>
                    {t("cancel_button")}
                  </Button>

                  <Button
                    variant="success"
                    type="submit"
                    disabled={(origin !== "Companies" && origin !== "SiteView" && this.state.role === "") || loading}
                    className="ml-2">
                    <Icon className="fas fa-user-check pr-2" />
                    {t("button_grant_access")}
                    {loading && <Loading />}
                  </Button>
                </Form.Group>
              </Form.Row>
            </Card.Body>
          </Card>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    pathRoot: getPathRootFromRoute(state),
    enterprise: getEnterpriseFromRoute(state, props),
    group: getGroupFromRoute(state, props),
    users: state.users,
  };
};
export default withT(
  connect(mapStateToProps)(ExistingUser),
  "user_management.user_invite"
);
